import { withHTMLComponent } from '@updater/ui-custom-element';

var html = "<div id=\"spinner\"></div>\n";

var styles = ":host {\n  display: inline-block;\n}\n\n/*\n   Credit to: https://codepen.io/6twenty/pen/tjpDr\n   Of course, renders a bit wobbly in IE11/Edge 🤷\n */\n#spinner {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  border: 0.1em solid #2b7499;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  box-sizing: border-box;\n}\n\n:host(.frozen) #spinner {\n  animation: none;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_withHTMLComponent) {
  _inherits(Spinner, _withHTMLComponent);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'connectedCallback',
    value: function connectedCallback() {
      this.className = window.UPD_FREEZE_ANIMATIONS ? 'frozen' : '';
    }
  }]);

  return Spinner;
}(withHTMLComponent(styles, html)());


customElements.define('upd-loading-spinner', Spinner);

export default Spinner;
